import { PagedResponse } from '../types';
import { Daswatch } from '../types/Device';

import DsmAxios from './DsmAxios';

// ------------------------ user api ---------------------------------------//

export const getUserDaswatches = ({
  params,
}: {
  params?: {
    dasId?: string;
    projectId?: string;
    assignedProject?: boolean;
    nextCursor?: string;
  };
}) => {
  return DsmAxios.get<PagedResponse<any>>('v1/daswatches', {
    params,
  });
};

export const getProjectDaswatches = (data: {
  projectId: string;
  params?: {
    prevCursor?: string;
    nextCursor?: string;
    dasId?: string;
  };
}) => {
  return DsmAxios.get<PagedResponse<Daswatch>>(
    `v1/projects/${data.projectId}/daswatches`,
    {
      params: data.params,
    },
  );
};

export const bindDaswatchToWorker = ({
  projectId,
  dasId,
  workerId,
}: {
  projectId: string;
  dasId: string;
  workerId: string;
}) => {
  return DsmAxios.put(`v1/projects/${projectId}/daswatches/${dasId}/worker`, {
    workerId,
  });
};

export const unbindDaswatch = ({
  projectId,
  dasId,
}: {
  projectId: string;
  dasId: string;
}) => {
  return DsmAxios.delete(`v1/projects/${projectId}/daswatches/${dasId}/worker`);
};
